import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalInteractionService {
  private selectedUserIdSignal = signal<string | null>(null);
  private selectedRowIndexSignal = signal<number | null>(null);
  private hoveredRowIndexSubject = new BehaviorSubject<number | null>(null);

  public hoveredRowIndex$ = this.hoveredRowIndexSubject.asObservable();

  public get selectedRowIndex(): number | null {
    return this.selectedRowIndexSignal();
  }

  public get selectedUserId(): string | null {
    return this.selectedUserIdSignal();
  }
  setHoveredRowIndex(index: number) {
    this.hoveredRowIndexSubject.next(index);
  }

  resetModalState() {
    this.selectedUserIdSignal.set(null);
    this.selectedRowIndexSignal.set(null);
  }

  setSelectedUserIdAndRowIndex(id: string, index: number) {
    this.selectedUserIdSignal.set(id);
    this.selectedRowIndexSignal.set(index);
  }
}
